export default class SkipLogicService {

    constructor(pollFilling) {
        this.pollFilling = pollFilling
    }

    decrementAndGetPreviousPage(page) {
        return (page <= 0) ? 0 : this.getPreviousPage(page - 1)
    }

    returnPageBasedOnSkipLogicAndPreviousResponses(page, answeredQuestionIds) {
        let found = false;
        const questions = this.pollFilling.database.questions[page - 1];
        for (const q in questions) {
          found = found || (answeredQuestionIds.indexOf(questions[q].id) !== -1)
          this.pollFilling.deleteQuestions(questions[q].id)
        }

        return found ? page : this.decrementAndGetPreviousPage(page)
    }

    getPreviousPage(page) {
        const answeredQuestionIds = Object.keys(this.pollFilling.answers).map(id => parseInt(id))
        return (answeredQuestionIds.length) ?
            this.returnPageBasedOnSkipLogicAndPreviousResponses(page, answeredQuestionIds)
            : page
    }

}
